import { useState } from 'react';
import { apiChangePassword } from './authApi';
import PasswordFields, { passwordError } from './PasswordFields';

// Changement de mot de passe depuis le menu utilisateur. Les autres sessions du compte
// (autres appareils) sont fermées par l'API ; celle-ci reste ouverte.
export default function ChangePasswordModal({ onClose }) {
    const [current, setCurrent] = useState('');
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const invalid = passwordError(password, confirmation);
        if (invalid) {
            setError(invalid);
            return;
        }
        setError(null);
        setSubmitting(true);
        try {
            await apiChangePassword(current, password);
            setDone(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="auth-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="change-password-title">
            <div className="auth-modal">
                <h2 id="change-password-title" className="auth-title">Changer de mot de passe</h2>
                {done ? (
                    <>
                        <p className="auth-subtitle">Mot de passe modifié. Vos sessions sur les autres appareils ont été fermées.</p>
                        <button type="button" className="auth-btn auth-btn--primary" onClick={onClose}>Fermer</button>
                    </>
                ) : (
                    <form className="auth-form" onSubmit={handleSubmit}>
                        <div className="auth-field">
                            <label htmlFor="current-password">Mot de passe actuel</label>
                            <input
                                id="current-password" type="password" autoComplete="current-password" required autoFocus
                                value={current} onChange={(e) => setCurrent(e.target.value)}
                            />
                        </div>
                        <PasswordFields
                            password={password} confirmation={confirmation}
                            onPasswordChange={setPassword} onConfirmationChange={setConfirmation}
                            autoFocus={false}
                        />
                        {error && <div className="auth-error" role="alert">{error}</div>}
                        <div className="auth-actions">
                            <button type="button" className="auth-btn auth-btn--ghost" onClick={onClose}>Annuler</button>
                            <button type="submit" className="auth-btn auth-btn--primary" disabled={submitting}>
                                {submitting ? 'Enregistrement…' : 'Enregistrer'}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
